import { InvoiceDTO, Permission, Res, TicketDTO } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import * as InvoiceStore from './InvoiceStore';
import * as InvoicePreconditions from './Preconditions';
import { reopenDocument, ReopenDocumentResult } from 'pos/modules/helpers/document-reopening';
import { Command } from 'pos/common';
import { ExternalPaymentsService } from 'pos/services';
import { InvoiceFacade } from 'pos/facades';
import { PaymentDTOFactory } from '../helpers/payments-processing';

declare global {
	interface CommandType {
		reopenInvoice: (invoice: InvoiceDTO) => Promise<Result<ReopenDocumentResult>>
	}
}

Command.register('reopenInvoice', Preconditions.ensure(Permission.Ticket_Reopen), async (invoice: InvoiceDTO): Promise<Result<ReopenDocumentResult>> => {

	async function handlePaymentsAndReopen(action: () => Promise<Result<TicketDTO>>): Promise<Result<TicketDTO>> {
		const invoicePayments = ExternalPaymentsService.forRefund('Refund', await InvoiceFacade.getTicketGlobalIdByInvoiceId(invoice.Id));

		// Devuelvo el dinero de la factura anterior.
		const amountToRefund = await InvoiceFacade.getLastCashAmountToRefund(invoice.Id);
		await invoicePayments.register(PaymentDTOFactory.createCash(amountToRefund));
		const invoicePaymentResult = await invoicePayments.commitCashPayments(0);
		if (!invoicePaymentResult.ok)
			return Result.error();

		const result = await action();
		if (!result.ok) {
			await invoicePayments.undoAll();
		}

		return result;
	}

	return reopenDocument({
		title: Res.Web.REOPEN_INVOICE(),
		canReopen: () => InvoicePreconditions.ensureCanReopen(invoice),
		reopen: location => handlePaymentsAndReopen(() => InvoiceStore.reopen(invoice.Id, location)),
		reopenInTicket: (location, targetId) => handlePaymentsAndReopen(() => InvoiceStore.reopenInTicket(invoice.Id, location, targetId)),
	});
});
